import PageHero from "../../components/sections/PageHero";
import GoldButton from "../../components/ui/GoldButton";
import SectionLabel from "../../components/ui/SectionLabel";

const products = [
  ["OWL Case Mind", "Litigation Platform", "Available", "Litigation management platform for law firms", "/products/casemind"],
  ["OWL ChatDesk", "AI Support", "Beta", "Customer support chatbot with your knowledge base", "/products/chatdesk"],
  ["OWL CallAgent", "AI Voice", "Coming Soon", "AI call centre platform for Indian SMBs", "/products/callagent"],
  ["OWL CRM", "CRM Platform", "Coming Soon", "Customisable CRM for Indian businesses", "/products/crm"],
  ["OWL ContentEngine", "AI Marketing", "Coming Soon", "AI content generation for marketing teams", "/products/contentengine"],
  ["OWL LeadFlow", "Sales AI", "Coming Soon", "AI lead generation and scoring platform", "/products/leadflow"],
  ["OWL InsightBoard", "Analytics", "Coming Soon", "AI-driven business analytics dashboard", "/products/insightboard"],
  ["OWL ContractReader", "LegalTech AI", "Coming Soon", "AI contract analysis and red-flag detection", "/products/contractreader"],
  ["OWL ReviewPulse", "Reputation AI", "Coming Soon", "AI review monitoring and response system", "/products/reviewpulse"],
];

const ProductsIndex = () => (
  <>
    <PageHero
      label="PRODUCTS"
      title="Built by us."
      titleAccent="Owned by you."
      subtitle="Purpose-built AI tools for specific Indian business problems. Buy once, deploy on your infrastructure."
    />

    <section style={{ background: "#050505", padding: "0 0 120px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
        <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: "30px clamp(20px, 4vw, 32px)", marginBottom: 36 }}>
          <SectionLabel text="PRODUCT LINE" />
          <div style={{ overflowX: "auto", marginTop: 22 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 760 }}>
              <thead>
                <tr>
                  {["Product", "Category", "Status", "Description", ""].map((heading) => (
                    <th key={heading || "cta"} style={{ textAlign: "left", padding: "14px 0", borderBottom: "1px solid rgba(212,168,67,0.18)", fontFamily: "'Barlow Condensed', sans-serif", fontSize: 12, letterSpacing: "0.18em", color: "#D4A843", textTransform: "uppercase" }}>
                      {heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {products.map(([name, category, status, description, href]) => (
                  <tr key={name}>
                    <td style={{ padding: "18px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", minWidth: 150 }}>
                      {name}
                    </td>
                    <td style={{ padding: "18px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#908A83" }}>
                      {category}
                    </td>
                    <td style={{ padding: "18px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)" }}>
                      <span style={{ padding: "6px 10px", borderRadius: 3, border: "1px solid rgba(212,168,67,0.24)", background: "rgba(212,168,67,0.06)", fontFamily: "'Barlow Condensed', sans-serif", fontSize: 11, letterSpacing: "0.16em", color: "#D4A843", textTransform: "uppercase" }}>
                        {status}
                      </span>
                    </td>
                    <td style={{ padding: "18px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", minWidth: 260 }}>
                      {description}
                    </td>
                    <td style={{ padding: "18px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)" }}>
                      {href ? <GoldButton href={href} size="sm">Learn More</GoldButton> : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ background: "#1A1208", border: "1px solid rgba(212,168,67,0.22)", borderRadius: 4, padding: 28 }}>
          <SectionLabel text="WHITE-LABEL" />
          <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
            All products are available for agencies and enterprises to resell under their own brand.
          </p>
        </div>
      </div>
    </section>
  </>
);

export default ProductsIndex;
